<template>
  <div style="padding:0 20px;">
    <Row type="flex" ref="cardgroup" :gutter="20">
      <Col
        v-for="(item, index) in userList"
        :key="index"
        :xxl="6"
        :xl="8"
        :lg="12"
        :sm="24"
        :xs="24"
      >
        <dragger :drag-target="item" :drag-data="item.unionId">
          <Card class="icard" :padding="0">
            <div
              class="card-wrapper"
              @click="cardClick(index)"
              @mouseover="cardHover(index)"
              @mouseout="cardOut(index)"
            >
              <!-- 左上角多选框 -->
              <div
                class="iconfont icon-checkbox"
                :class="[
                  item.clickCheck ? 'icon-duoxuan1' : 'icon-duoxuankuang1'
                ]"
                @click.stop="clickCheck(item, index)"
              ></div>
              <!-- 右上角叉叉 -->
              <div
                class="iconfont icon-chushaixuanxiang icon-cha"
                v-show="item.showCha"
                @click.stop="clickCha(item, index)"
              ></div>
              <!-- 卡片上 -->
              <div class="card-top">
                <img
                  class="headpic"
                  :src="
                    item.headPicUrl || require('@/assets/images/default.png')
                  "
                />
                <div class="rightcontent">
                  <div class="pname">{{ item.realName || "暂无姓名" }}</div>
                  <div class="ptype">{{ item.name }}</div>
                  <div class="box juese">
                    <img
                      v-if="item.isParty"
                      :src="require('@/assets/images/party.png')"
                    />
                    <img
                      v-if="item.isVol"
                      :src="require('@/assets/images/volunteer.png')"
                    />
                  </div>
                </div>
                <!-- 左侧标签 -->
                <!-- <div
                  class="authstate"
                  :class="authClass(item.authState)"
                >{{item.authState==1?'已实名':(item.authState==0?'未认证':'待审核')}}</div> -->
              </div>
              <!-- 卡片下 -->
              <div class="from-wrapper">
                <!-- 居民页用 以下 -->
                <div
                  v-for="_item in item.orglist"
                  :key="_item.zoneType"
                  class="from"
                >
                  <span
                    class="iconfont icon-tubiaozhizuomoban icon verified"
                    v-if="_item.realNameStatus == 1"
                  ></span>
                  <span
                    class="iconfont icon-weirenzheng- icon noVerify"
                    v-else-if="_item.realNameStatus == 0"
                  ></span>
                  <span
                    class="iconfont icon-dengdai icon verifying"
                    v-else
                  ></span>
                  <span>{{ _item.zoneName }}</span>
                </div>
              </div>
            </div>
          </Card>
        </dragger>
      </Col>
    </Row>
  </div>
</template>

<script>
import dragger from "../../../components/dragger/drag";
var that;
export default {
  name: "sqfwCard",
  components: {
    dragger
  },
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    checkList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dragstart: false,
      cardItemWidth: 280, // 设为0 可动态获取 宽度
      marginLeft: "",
      isShowDelete: false,
      deleteUnionid: "",
      newCheckList: []
    };
  },
  methods: {
    /* 点击 */
    cardClick(index) {
      this.$emit("cardClick", this.userList[index]);
    },
    cardHover(index) {
      this.userList[index].showCha = true;
    },
    cardOut(index) {
      this.userList[index].showCha = false;
    },
    clickCha(item, index) {
      this.$emit("delPeople", {
        unionId: item.unionId,
        communityId: item.communityId,
        appType:item.appType
      });
    },
    clickCheck(item, index) {
      item.clickCheck = !item.clickCheck;
      if (this.newCheckList.indexOf(item) == -1) {
        this.newCheckList.push(item);
      } else {
        this.newCheckList.splice(this.newCheckList.indexOf(item), 1);
      }
      this.$emit("checkList", this.newCheckList);
    },
    authClass: function(state) {
      return {
        verified: state == 1,
        verifying: state == -1,
        noVerify: state == 0
      };
    },
    getMargin() {
      this.$nextTick()
        .then(() => {
          if (this.$refs.cardgroup) {
            let boxWidth = this.$refs.cardgroup.$el.clientWidth;
            let count = Math.floor(boxWidth / this.cardItemWidth) + 1;
            let rest = boxWidth % this.cardItemWidth;
            this.marginLeft = rest / count + "px";
          }
        })
        .catch(e => console.log(e));
    }
  },
  watch: {
    userList: function() {
      //  没有初始化时执行
      if (!this.cardItemWidth) {
        // 有数据时执行
        if (this.$refs.cardgroup.$children.length > 0) {
          this.cardItemWidth = this.$refs.cardgroup.$children[0].$el.clientWidth;
          this.getMargin();
        }
      }
    },
    checkList(val){
      // 简单克隆传入数据
      this.newCheckList = JSON.parse(JSON.stringify(val))
    }
  },
  created() {
    that = this;
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.card-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 203px;
  border-radius: 6px;
}
.authstate {
  position: absolute;
  left: 100px;
  top: 115px;
  width: 82px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
}
.icard {
  margin-bottom: 20px;
  border-radius: 6px;
}
.card-top {
  height: 122px;
  display: flex;
  border-bottom: 1px solid #eee;
  padding-top: 20px;
}
.headpic {
  margin-left: 60px;
  display: inline-block;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  // box-shadow: 2px 2px 4px 1px #898989;
  // 处理 图片加载失败的hack
  overflow: hidden;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
  }
}
.rightcontent {
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 25px;
}
.ptype {
  font-size: 14px;
  color: #909090;
}
.pname {
  font-size: 20px;
  color: #4b4b4b;
}
.juese {
  img {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    margin-top: 8px;
  }
}
.from-wrapper {
  display: flex;
  flex-direction: column;
  height: 80px;
  padding: 20px;
}
.from {
  padding-bottom: 5px;
}

.icon {
  padding-right: 5px;
  color: #cdcdcd;
}
.icon-cha {
  position: absolute;
  right: 20px;
  top: 15px;
  color: #cdcdcd;
  font-size: 20px;
}
.icon-checkbox {
  position: absolute;
  top: 15px;
  left: 20px;
  color: #cdcdcd;
  font-size: 20px;
}
.icon-duoxuan1 {
  color: #d22c2b;
}
.icon-dangzhibugongzuo {
  color: #fe583e;
}
/* 认证状态 */
.verified {
  color: #47ba54;
}
.verifying {
  color: #ff7744;
}
.noVerify {
  color: #a1afb3;
}
</style>
